import { render, staticRenderFns } from "./EditSubAccount.vue?vue&type=template&id=74008d75&"
import script from "./EditSubAccount.vue?vue&type=script&lang=js&"
export * from "./EditSubAccount.vue?vue&type=script&lang=js&"
import style0 from "./EditSubAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports